var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "-2.5 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "paper") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons",
    stroke: "none",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "ui-gambling-website-lined-icnos-casinoshunter",
    transform: "translate(-476.000000, -284.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "square-filled",
    transform: "translate(50.000000, 120.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M447.017693,164 C447.504179,164 447.973985,164.177317 448.339153,164.498753 L452.32146,168.004143 C452.752813,168.383838 453,168.930731 453,169.505391 L453,193 C453,194.656854 451.656854,196 450,196 L429,196 C427.343146,196 426,194.656854 426,193 L426,167 C426,165.343146 427.343146,164 429,164 L447.017693,164 Z M446,166 L429,166 C428.447715,166 428,166.447715 428,167 L428,193 C428,193.552285 428.447715,194 429,194 L450,194 C450.552285,194 451,193.552285 451,193 L451,172 L448.659002,172 C447.198488,172 446.085129,170.710688 446.004662,169.160652 L446,168.980703 L446,166 Z M451,169.505391 L448,166.865 L448,168.980703 C448,169.535984 448.292436,169.934644 448.585808,169.992691 L448.659002,170 L451,170 L451,169.505391 Z",
    id: "paper"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaper);
export default __webpack_public_path__ + "static/media/paper.bbfb982ecde1b1a152d1269d102e366c.svg";
export { ForwardRef as ReactComponent };